import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Lista from "./Lista";
import Inserir from "./Inserir";
import Editar from "./Editar";

const Index = ({ match }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/inserir`} component={Inserir} />
      <Route path={`${match.url}/editar/:codigo`} component={Editar} />
    </Switch>
  </div>
);

export default Index;
